var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.kase.status === 'PENDING')?_c('v-btn',{staticClass:"rounded-lg",attrs:{"x-large":"","color":"primary","width":"100%"},on:{"click":function($event){return _vm.triggerStartJob()}}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v(" mdi-progress-wrench ")]),_vm._v(" "+_vm._s(_vm.i18n("startJob"))+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }